import { ReactNode, useState } from 'react'
import Header from './Header'
import Sidebar from './Sidebar'
import Footer from './Footer'
import ApiErrorToast from '@/components/common/ApiErrorToast'
import FlyteSyncToast from '@/components/common/FlyteSyncToast'
import SalesforceSyncToast from '@/components/common/SalesforceSyncToast'
import XeroSyncToast from '@/components/common/XeroSyncToast'
import RoleAccessGuard from '@/components/auth/RoleAccessGuard'

interface LayoutProps {
  children: ReactNode
}

const Layout = ({ children }: LayoutProps) => {
  const [sidebarOpen, setSidebarOpen] = useState(false)

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
      <div className="flex flex-1 pt-[92px]">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <main className="flex-1 overflow-x-hidden bg-gray-50 lg:ml-[242px]">
          <div className="container-responsive py-4 sm:py-6 px-4 sm:px-6" style={{ maxWidth: '100%', width: '100%' }}>
            <RoleAccessGuard>{children}</RoleAccessGuard>
          </div>
        </main>
      </div>
      <Footer />
      <ApiErrorToast />
      <FlyteSyncToast />
      <SalesforceSyncToast />
      <XeroSyncToast />
    </div>
  )
}

export default Layout

